import React, { useMemo, useState } from "react";
import UserSideBar from "./UserSideBar";
import { Outlet } from "react-router-dom";
import "./UserLayout.css";
import Header from "../../../Pages/Components/Headers/Header";
import Footer from "../../../Pages/Components/Footers/Footer";
import {
  AuthenticateUser,
  UserLocationFetcher,
} from "../../../Redux/Slices/User_Slices/User-SLICE";
import { useDispatch, useSelector } from "react-redux";

const UserLayout = () => {
  return (
    <>
      <Header />
      <div className="user-panel proxima_regular">
        <div className="aside-main">
          <UserSideBar />
          <div className="userdb-content">
            <Outlet />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default UserLayout;
